import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./utils/rem.js";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import vueAwesomeSwiper from "vue-awesome-swiper";
import Carousel3d from "vue-carousel-3d";
import BaiduMap from "vue-baidu-map";

Vue.use(BaiduMap, {
  ak: "IYsSIj2PEmrfck4uJUTKYDZdK13eVKmY",
});
Vue.use(Carousel3d);

Vue.use(vueAwesomeSwiper);

Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
